import React from 'react';
import { useRealtimeStatus, CONNECTION_STATUS } from '../hooks/useJobsRealtime';

const STATUS_CONFIG = {
  [CONNECTION_STATUS.CONNECTED]: { color: 'bg-green-500', title: 'Realtime connected' },
  [CONNECTION_STATUS.CONNECTING]: { color: 'bg-yellow-500 animate-pulse', title: 'Connecting...' },
  [CONNECTION_STATUS.DISCONNECTED]: { color: 'bg-gray-400', title: 'Disconnected (tab hidden)' },
  [CONNECTION_STATUS.ERROR]: { color: 'bg-red-500', title: 'Connection error' },
};

const RealtimeIndicator = () => {
  const status = useRealtimeStatus();
  const config = STATUS_CONFIG[status] || { color: 'bg-gray-400', title: 'Unknown' };

  return (
    <div className="flex items-center" title={config.title}>
      <div className={`w-2 h-2 rounded-full ${config.color}`} />
    </div>
  );
};

export default RealtimeIndicator;

